/** XeAgents.ai**/
import { useTranslation } from "react-i18next";

/** FREE_CREDITS_TERMS in the visitor's language, in the same order. */
export function useFreeCreditTerms(): string[] {
  const { t } = useTranslation("landing");
  return [t("credits.noCard"), t("credits.noSetup"), t("credits.startMinutes")];
}
